import * as React from 'react';

export const SjaelvtestIcon = props => (
  <svg
    id="Lager_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 180.6 53.4"
    style={{
      enableBackground: 'new 0 0 180.6 53.4',
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.st0{fill:#fff}.st1{fill:#020203}'}</style>
    <path className="st0" d="M.5.5H180v52.4H.5z" />
    <path className="st1" d="M179.5 1v51.4H1V1h178.5m1.1-1H0v53.4h180.6V0z" />
    <path
      className="st0"
      d="M31.9 47.8c-5.5-.1-10.7-2.3-14.6-6.2-3.9-4-6-9.2-5.9-14.8.1-11.3 9.4-20.6 20.8-20.6h.2c5.5.1 10.7 2.3 14.6 6.2 3.9 4 6 9.2 5.9 14.8-.1 11.3-9.4 20.6-20.8 20.6h-.2z"
    />
    <path
      className="st1"
      d="M32.1 5.7v1h.2c5.4.1 10.5 2.2 14.3 6.1 3.8 3.9 5.8 9 5.8 14.4-.1 11.1-9.2 20.1-20.3 20.1h-.2c-5.4-.1-10.5-2.2-14.3-6.1-3.8-3.9-5.8-9-5.8-14.4.1-11.1 9.2-20.1 20.3-20.1v-1m0 0c-11.6 0-21.1 9.4-21.3 21-.1 11.7 9.3 21.4 21 21.5h.2c11.6 0 21.1-9.4 21.3-21 .1-11.7-9.3-21.4-21-21.5h-.2z"
    />
    <linearGradient
      id="SVGID_1_"
      gradientUnits="userSpaceOnUse"
      x1={13.39}
      y1={-303.208}
      x2={50.604}
      y2={-303.208}
      gradientTransform="rotate(180 32 -141.768)"
    >
      <stop
        offset={0}
        style={{
          stopColor: '#e41913',
        }}
      />
      <stop
        offset={0.097}
        style={{
          stopColor: '#ea6516',
        }}
      />
      <stop
        offset={0.215}
        style={{
          stopColor: '#f3a518',
        }}
      />
      <stop
        offset={0.312}
        style={{
          stopColor: '#f9cd1a',
        }}
      />
      <stop
        offset={0.384}
        style={{
          stopColor: '#fde31a',
        }}
      />
      <stop
        offset={0.423}
        style={{
          stopColor: '#feeb1a',
        }}
      />
      <stop
        offset={0.623}
        style={{
          stopColor: '#dfde20',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#009245',
        }}
      />
    </linearGradient>
    <path
      d="M47.2 26.7c-2.2-18.6-27.8-19-30.4 0"
      style={{
        fill: 'none',
        stroke: 'url(#SVGID_1_)',
        strokeWidth: 6.7742,
        strokeLinecap: 'round',
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="m27.7 27.3 8.8-15.8-1.8 18c-.6 1.9-2.7 3-4.6 2.4s-3-2.7-2.4-4.6z"
      style={{
        fill: '#1e1e1c',
      }}
    />
    <path
      className="st1"
      d="M76.5 30.5c0 .7-.2 1.4-.5 2s-.8 1.2-1.4 1.7c-.6.5-1.4.9-2.2 1.2-.8.3-1.9.4-3.1.4-1.3 0-2.4-.1-3.4-.4-1-.2-2.1-.6-3.1-1.1v-3h.2c.9.7 1.9 1.3 3.1 1.7 1.2.4 2.3.6 3.3.6 1.5 0 2.6-.3 3.4-.8.8-.5 1.2-1.3 1.2-2.2 0-.8-.2-1.4-.6-1.7s-1-.7-1.8-.9c-.6-.2-1.2-.3-1.9-.4-.7-.1-1.4-.2-2.2-.4-1.6-.3-2.7-.9-3.5-1.7-.8-.8-1.1-1.9-1.1-3.1 0-1.5.6-2.7 1.9-3.6 1.3-.9 2.8-1.4 4.8-1.4 1.2 0 2.4.1 3.4.4 1 .2 2 .5 2.8.9v2.8h-.2c-.7-.6-1.6-1-2.7-1.4-1.1-.4-2.2-.6-3.4-.6-1.3 0-2.3.3-3 .8-.8.5-1.1 1.2-1.1 2 0 .7.2 1.3.6 1.7.4.4 1.1.7 2 1 .5.1 1.2.2 2.2.4.9.2 1.7.3 2.4.5 1.3.3 2.3.9 3 1.6.5.8.9 1.8.9 3zM84.3 35.9c0 1.6-.4 2.7-1.2 3.5s-1.9 1.2-3.2 1.2c-.3 0-.7 0-1.3-.1-.5-.1-1-.1-1.3-.2v-2.1h.1c.2.1.5.2.9.3.4.1.7.2 1.1.2.6 0 1-.1 1.4-.2.3-.2.6-.4.8-.7.2-.3.3-.7.3-1.1.1-.4.1-1 .1-1.6V24.2h-2.8v-1.9h5v13.6zm.2-15.8H82v-2.3h2.5v2.3zM99.3 35.6H97v-1.4c-.2.1-.5.3-.8.6s-.7.4-1 .6c-.4.2-.8.3-1.3.5-.5.1-1.1.2-1.7.2-1.2 0-2.2-.4-3-1.2-.8-.9-1.2-1.9-1.2-3.2 0-1 .2-1.8.6-2.4.4-.6 1-1.1 1.8-1.5.8-.4 1.8-.6 2.9-.7 1.1-.1 2.4-.2 3.7-.3v-.3c0-.5-.1-.9-.3-1.3s-.4-.6-.8-.8c-.3-.2-.7-.3-1.1-.4-.4-.1-.9-.1-1.4-.1-.6 0-1.2.1-2 .2-.7.2-1.5.4-2.2.7h-.1v-2.3c.4-.1 1.1-.3 1.9-.4.8-.1 1.6-.2 2.4-.2.9 0 1.8.1 2.4.2.7.2 1.3.4 1.8.8s.9.8 1.1 1.4.4 1.3.4 2.2v9.1zM97 32.3v-3.7c-.7 0-1.5.1-2.4.2s-1.6.2-2.2.3c-.6.2-1.2.5-1.6.9-.4.4-.6.9-.6 1.6 0 .8.2 1.3.7 1.7.5.4 1.2.6 2.1.6.8 0 1.5-.2 2.2-.5.7-.3 1.3-.7 1.8-1.1zm-4.2-12.2h-2.4v-2.3h2.4v2.3zm5 0h-2.4v-2.3h2.4v2.3zM106.1 35.6h-2.2V17.1h2.2v18.5zM122.2 22.3l-5.4 13.3h-2.2l-5.3-13.3h2.4l4.1 10.6 4.1-10.6h2.3zM132.3 35.5c-.4.1-.9.2-1.4.3-.5.1-.9.1-1.3.1-1.4 0-2.4-.4-3.1-1.1-.7-.7-1.1-1.9-1.1-3.5v-7.1h-1.5v-1.9h1.5v-3.8h2.2v3.8h4.6v1.9h-4.6V31.9c0 .4.1.8.3 1.1.2.3.4.5.7.7.3.1.8.2 1.4.2.4 0 .7-.1 1.1-.2.4-.1.7-.2.9-.3h.1v2.1zM146.4 29.2h-9.8c0 .8.1 1.5.4 2.1.2.6.6 1.1 1 1.5.4.4.9.7 1.5.9.6.2 1.2.3 1.9.3.9 0 1.8-.2 2.7-.5.9-.4 1.6-.7 2-1.1h.1v2.4c-.8.3-1.5.6-2.3.8s-1.6.3-2.5.3c-2.2 0-3.9-.6-5.2-1.8-1.2-1.2-1.9-2.9-1.9-5.1 0-2.2.6-3.9 1.8-5.2 1.2-1.3 2.7-1.9 4.7-1.9 1.8 0 3.2.5 4.1 1.6 1 1 1.5 2.5 1.5 4.5v1.2zm-2.2-1.7c0-1.2-.3-2.1-.9-2.7s-1.5-1-2.7-1c-1.2 0-2.2.4-2.9 1.1-.7.7-1.1 1.6-1.2 2.6h7.7zM159.5 31.7c0 1.2-.5 2.2-1.5 3s-2.4 1.2-4.1 1.2c-1 0-1.9-.1-2.7-.4-.8-.2-1.5-.5-2.1-.8v-2.5h.1c.7.5 1.5 1 2.4 1.3s1.7.5 2.5.5c1 0 1.8-.2 2.3-.5.6-.3.8-.8.8-1.5 0-.5-.2-.9-.5-1.2s-.9-.5-1.7-.7c-.3-.1-.7-.2-1.2-.3-.5-.1-1-.2-1.4-.3-1.2-.3-2-.8-2.5-1.4-.5-.6-.7-1.3-.7-2.2 0-.5.1-1.1.3-1.5.2-.5.6-.9 1-1.3s1-.7 1.7-.9c.7-.2 1.5-.3 2.3-.3.8 0 1.6.1 2.4.3.8.2 1.5.4 2 .7v2.4h-.1c-.6-.4-1.3-.8-2.1-1.1-.8-.3-1.6-.4-2.4-.4-.8 0-1.5.2-2.1.5-.6.3-.8.8-.8 1.4 0 .5.2 1 .5 1.2.3.3.9.5 1.6.7.4.1.9.2 1.4.3.5.1.9.2 1.3.3 1 .2 1.8.6 2.4 1.2.6.6.9 1.4.9 2.3zM169.9 35.5c-.4.1-.9.2-1.4.3-.5.1-.9.1-1.3.1-1.4 0-2.4-.4-3.1-1.1-.7-.7-1.1-1.9-1.1-3.5v-7.1h-1.5v-1.9h1.5v-3.8h2.2v3.8h4.6v1.9h-4.6V31.9c0 .4.1.8.3 1.1.2.3.4.5.7.7.3.1.8.2 1.4.2.4 0 .7-.1 1.1-.2.4-.1.7-.2.9-.3h.1v2.1z"
    />
  </svg>
);
